module.exports = __webpack_public_path__ + "static/media/9.d2d89f2.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/9.wav
// module id = lc3g
// module chunks = 0